import { render, staticRenderFns } from "./StackedStatesCases.vue?vue&type=template&id=379674fe&scoped=true"
import script from "./StackedStatesCases.vue?vue&type=script&lang=js"
export * from "./StackedStatesCases.vue?vue&type=script&lang=js"
import style0 from "./StackedStatesCases.vue?vue&type=style&index=0&id=379674fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379674fe",
  null
  
)

export default component.exports